<template>
  <!-- 客服弹框 -->
  <div class="public_kefu_logo">
    <img src="@/assets/images/home/kefu_logo.gif" />
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    props: {
      kefu_type: {
        type: Number,
        default: 1 //
      }
    },
    components: {},
    created() {
      //this.kefu();
    },
    computed: {},
    methods: {}
  }
</script>

<style scoped="scoped">
  .public_kefu_logo {
    position: fixed;
    right: 30px;
    bottom: 10%;
    z-index: 9999;
    cursor: pointer;
  }

  .public_kefu_logo>img {
    display: block;
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-kefu/public-kefu.vue